import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';

Vue.component("entity-treeview-management", {
	props: ["data", "selected"],
	data() {
		return {			
			counter: 0,
			selectedEntityId: this.selected
		};
	},
	computed: {
		treeData: function() {
			return new Tree(this.data);
		},
		coverageExclusionTooltipLabel: function () {
			return window.labels.coverageExclusionTooltip;
		}
	},
	methods: {
		selectNode: function (params) {
			const self = this;			

			self.currentNode = params;
			self.counter += 1;
			self.selectedEntityId = params.id + '|' + self.counter;			

			this.$emit('update:selected', self.selectedEntityId);
		}
	},
	template: `
		<vue-tree-list
			:model="treeData"
			v-bind:default-expanded="false">
			<template v-slot:leafNameDisplay="props">
				<div class="entity-row" :id="'entity_' + props.model.id">					
					<i v-if="props.model.excluded" class="fas fa-ban mt-2 pr-2 has-text-danger" :title="coverageExclusionTooltipLabel"></i>
					<div style="cursor: pointer" v-if="props.model.referenceNumber != null && props.model.referenceNumber != undefined && props.model.referenceNumber != ''" class="entity-row-reference-number pr-2" @click.prevent="selectNode(props.model)">{{ props.model.referenceNumber }}</div>
					<div style="cursor: pointer" class="entity-row-display-name" v-html="props.model.name" @click.prevent="selectNode(props.model)"></div>
				</div>				
			</template>
			<template v-slot:treeNodeIcon="props">
				<span class="icon">					
					<i v-if="props.model.children && props.model.children.length > 0 && !props.model.isNote" class="fa fa-sitemap"></i>
					<i v-else-if="props.model.showNoteIcon" class="fa fa-comment has-text-info"></i>
					<i v-else class="fa fa-fw"></i>					
				</span>
			</template>
		</vue-tree-list>
	`
});